/**
 * api接口的统一出口
 */
//登陆模块
import login from './login';

/* 表格数据列表模块 */
import dataList from './dataList.js'

// 导出接口
export default {
  login,
  dataList
}



// WEBPACK FOOTER //
// ./src/api/request/index.js